import React from 'react';
import { Avatar } from 'antd';
import EventSeatIcon from '@material-ui/icons/EventSeat';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import { Tag } from 'antd';
import { AvatarContainer, AvatarIconContainer } from './style';
import theme from '../../shared/theme';
import USER_DEFAULT_IMG from '../../img/default_avatar.svg';
import GROUP_DEFAULT_IMG from '../../img/default_avatar.svg';

export const ROLE = {
  EXPERT: 'EXPERT',
  CHAIR: 'CHAIR',
  CGA: 'CGA',
};
export const AVATAR_TYPE = {
  USER: 'USER',
  GROUP: 'GROUP',
  CGA: 'CGA',
};

const DEFAULT_SRC = {
  USER: USER_DEFAULT_IMG,
  GROUP: GROUP_DEFAULT_IMG,
};

/**
 *
 * @returns {string} display name for this user
 */
export const getDisplayName = user => {
  return (
    `${user?.firstName ? user?.firstName[0] : ''}${
      user?.lastName ? user?.lastName[0] : ''
    }` || ''
  );
};

/**
 *
 * @param {*} props.name name to display (you can use getDisplayName from this component to generate)
 * @param {*} props.role ROLE.EXPERT | ROLE.CHAIR
 * @param {boolean} props.isCGA
 * @param {*} props.type AVATAR_TYPE.USER | AVATAR_TYPE.GROUP
 * @param {*} props.preFix prefix the className of the component (default value: 'default')
 * @param {*} rest antd Avatar props: https://ant.design/components/avatar-cn/#API
 */
const DsAvatar = props => {
  const [colorIndex] = React.useState(Math.floor(Math.random() * 10 + 1));
  const { src, name, role, type, preFix, getColorIndex, isCGA, ...rest } = {
    type: AVATAR_TYPE.USER,
    preFix: 'default',
    src: DEFAULT_SRC[AVATAR_TYPE],
    isCGA: false,
    ...props,
  };
  React.useEffect(() => {
    if (getColorIndex) {
      getColorIndex(colorIndex);
    }
  }, [getColorIndex, colorIndex]);
  return (
    <>
      <AvatarContainer
        colorIndex={colorIndex}
        className={`${preFix}-avatar-container`}
      >
        {src ? (
          <Avatar className={`${preFix}-src-avatar`} {...rest} src={src} />
        ) : (
          <Avatar className={`${preFix}-avatar`} {...rest}>
            {' '}
            {name}
          </Avatar>
        )}
        {role === ROLE.EXPERT && (
          <AvatarIconContainer background={theme.main.base_color}>
            <VerifiedUserIcon
              style={{
                color: '#ffffff',
                fontSize: '15px',
                borderRadius: '50%',
                background: theme.main.base_color,
              }}
            />
          </AvatarIconContainer>
        )}
        {isCGA && (
          <AvatarIconContainer
            background={theme.main.base_color}
            style={{
              top: '0px',
              right: '-18px',
            }}
          >
            <Tag
              color="#12c39a"
              style={{
                borderRadius: '20px',
                fontWeight: '600',
              }}
            >
              CGA
            </Tag>
          </AvatarIconContainer>
        )}
        {role === ROLE.CHAIR && (
          <AvatarIconContainer background={'#fdaa01'}>
            <EventSeatIcon
              style={{
                color: '#ffffff',
                fontSize: '15px',
                borderRadius: '50%',
                background: '#fdaa01',
              }}
            />
          </AvatarIconContainer>
        )}
      </AvatarContainer>
    </>
  );
};

export default DsAvatar;
